export { VpTableSkeleton } from './VpTableSkeleton';



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpTableSkeleton/index.js